import { Link } from "react-router-dom";
import { CATEGORY_LABELS, formatPrice } from "../lib/api";

export default function ProductCard({ product }) {
  const hasVariants = product.variants && product.variants.length > 0;
  const minPrice = hasVariants
    ? Math.min(...product.variants.map((v) => v.price))
    : product.sale_price || product.price;
  const onSale = !hasVariants && product.sale_price;

  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block bg-white border border-[#E6DFD3] rounded-sm overflow-hidden transition-transform duration-300 hover:-translate-y-1 hover:shadow-[0_12px_30px_-12px_rgba(45,55,43,0.25)]"
    >
      <div className="aspect-square overflow-hidden bg-[#F0EBE1] relative">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {onSale && (
          <span className="absolute top-3 left-3 bg-[#B85C38] text-white text-[11px] uppercase tracking-wider px-2.5 py-1">
            Sale
          </span>
        )}
      </div>
      <div className="p-5">
        <p className="kicker">{CATEGORY_LABELS[product.category] || product.category}</p>
        <h3 className="font-serif text-xl text-[#2D372B] mt-1 leading-tight">{product.name}</h3>
        <div className="mt-2 flex items-baseline gap-2">
          {hasVariants && <span className="text-xs text-[#7C897B]">from</span>}
          <span className="font-sans text-[#B85C38] text-lg">{formatPrice(minPrice)}</span>
          {onSale && (
            <span className="text-sm text-[#7C897B] line-through">{formatPrice(product.price)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
